import script from "./ScrollToTop.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollToTop.vue?vue&type=script&setup=true&lang=js"

import "./ScrollToTop.vue?vue&type=style&index=0&id=3e992c3c&lang=scss"

const __exports__ = script;

export default __exports__